<template>
  <div>
    <CrudGrid
      :footer-text="$t('messages.items_per_page')"
      :headers="headers"
      :items="reason_not_captureds"
      :loading="loading"
      :page="page"
      :options.sync="options"
    >
      <template v-slot:header>
        <div class="header-table">
          <CrudFilter :has-filters="hasFilters" @search="applyFilter" @clear="clearFilter">
            <v-list-item>
              <v-text-field
                color="#086318"
                :label="$t('inputs.reasons_not_validation.description')"
                class="rounded-lg"
                hide-details
                outlined
                dense
                v-model="filterForm.description"
              />
            </v-list-item>
            <v-list-item>
              <v-select
                color="#086318"
                :label="$t('inputs.reasons_not_captation.type_use')"
                class="rounded-lg"
                hide-details
                outlined
                dense
                clearable
                :items="types_reasons"
                item-text="description"
                item-value="id"
                v-model="filterForm.type"
              />
            </v-list-item>
            <v-list-item>
              <v-select
                color="#086318"
                :label="$t('inputs.reasons_not_captation.type_captation')"
                class="rounded-lg"
                hide-details
                outlined
                dense
                clearable
                :disabled="isCaptationDisabled"
                :items="types_captations"
                item-text="description"
                item-value="id"
                v-model="filterForm.type_captation"
              />
            </v-list-item>
            <v-list-item>
              <v-select
                color="#086318"
                :label="$t('inputs.reasons_not_captation.type_orgon')"
                class="rounded-lg"
                hide-details
                outlined
                dense
                clearable
                :disabled="isOrgonDisabled"
                :items="orgons_type"
                item-text="description"
                item-value="id"
                v-model="filterForm.type_orgon"
              />
            </v-list-item>
          </CrudFilter>
          <v-btn class="rounded-lg ml-2" elevation="1" color="#41916b" @click="openDialog()">
            <span class="textBtn">{{$t('buttons.new')}}</span>
          </v-btn>
        </div>
      </template>

      <template v-slot:[`item.actions`]="{ item }">
        <Menu :resource="item" @editItemGrid="openDialog(item)">
          <ChangeStatus
            :resource="item"
            typeData="not-delete"
            @updateGrid="loadGridData()"
            url="reason_not_captureds"
          />
        </Menu>
      </template>

      <template v-slot:[`item.status`]="{ item }">
        <v-chip :color="item.deleted_at ? '#fa5252' : '#bedfc5'" dark>
          {{ item.deleted_at ? 'Inativo' : 'Ativo' }}
        </v-chip>
      </template>

      <template v-slot:[`item.type_use`]="{item}">
        <v-chip :color="typeUseColor(item.type_reason_not_captured.description)" dark>
          {{ item.type_reason_not_captured.description }}
        </v-chip>
      </template>

      <template v-slot:[`item.type_captation_or_orgon`]="{item}">
          {{ typeCaptationOrOrgon(item) }}
      </template> 
    </CrudGrid>

    <Modal v-model="dialog">
      <MotivoNaoCaptacaoForm
        :openDialog="dialog"
        :resource="resource"
        @closeDialog="dialog = false, loadGridData()"
      />
    </Modal>
  </div>
</template>

<script>
import {
  getReasonNotCaptations,
  getTypeReasonNotCaptureds,
  getTypeCaptations,
} from "@/service/basic-registrations/ReasonNotCaptationService";
import { getTypeOrgons } from "@/service/basic-registrations/OrgonsTissuesService";
import { mapActions } from "vuex";
import MotivoNaoCaptacaoForm from "./ReasonNotCaptation.vue";
import Menu from "../widgets/MenuActions-comp.vue";
import ChangeStatus from "../widgets/ChangeStatus-comp.vue";
import CrudGrid from "../widgets/Grid.vue";
import CrudFilter from "../widgets/Filter.vue";
import Modal from "../widgets/Modal.vue";

export default {
  data() {
    return {
      dialog: false,
      loading: false,
      reason_not_captureds: [],
      filterForm: {
        description: '',
        type: '',
        type_captation: '',
        type_orgon: '',
      },
      types_reasons: [],
      types_captations: [],
      orgons_type: [],
      options: {},
      headers: [
        { text: "DESCRIÇÃO", align: "start", value: "description" },
        { text: "TIPO DE USO DO MOTIVO", align: "start", value: "type_use" },
        { text: "TIPO DA CAPTAÇÃO/TIPO DE ORGÃO E TECIDO", align: "start", value: "type_captation_or_orgon" },
        { text: "STATUS", align: "start", value: "status" },
        { text: "Ações", value: "actions", sortable: false, align: "center" },
      ],
      page: 0,
      resource: {},
      actions: [
        {
          name: "Editar",
          type: "modal",
          route: "",
          encryptionName: "",
          encryptionPassword: "",
          componentName: "MotivoNaoCaptacaoForm",
        },
      ],
    };
  },

  components: {
    Modal, 
    CrudFilter,
    CrudGrid,
    Menu,
    ChangeStatus,
    MotivoNaoCaptacaoForm 
  },

  computed: {
    hasFilters() {
      return !!(
        this.filterForm.description ||
        this.filterForm.type ||
        this.filterForm.type_captation ||
        this.filterForm.type_orgon
      );
    },
    isCaptationDisabled() {
      return !this.filterForm.type || this.filterForm.type == 2;
    },
    isOrgonDisabled() {
      return !this.filterForm.type || this.filterForm.type == 1;
    },
  }, 

  async created() {
    this.changeActionsData(this.actions);

    const [types_reasons, types_captations, orgons_type] = await Promise.all([
      getTypeReasonNotCaptureds(),
      getTypeCaptations(),
      getTypeOrgons(),
    ]);

    this.types_reasons = types_reasons;
    this.types_captations = types_captations;
    this.orgons_type = orgons_type;
  },

  mounted() {
    this.loadGridData();
  },

  methods: {
    ...mapActions(["changeSnackBarData", "changeActionsData"]),

    typeUseColor(description) {
        if(description == 'Não efetivação da captação') return '#bedfc5';
        if(description == 'Não captação por Órgão') return '#54b889';
        return undefined;
    },

    typeCaptationOrOrgon(item) {
      return item.type_captation?.description || item.type_orgon?.description || '-';
    }, 

    loadGridData() {
      this.loading = true; 
      
      getReasonNotCaptations(this.filterForm).then((result) => {
        this.loading = false;
        this.reason_not_captureds = result;
      });
    },

    openDialog(item) {
      this.resource = item || {};
      this.dialog = true;
    },

    applyFilter() {
      this.loadGridData();
    },

    clearFilter() {
      this.filterForm = {
        description: '',
        type: '',
        type_captation: '',
        type_orgon: '',
      };
      this.loadGridData();
    },
  },
};
</script>

<style scoped>
.textBtn {
  font-family: "Poppins";
  color: #ffffff;
}
</style>
